module.exports = __webpack_public_path__ + "9dee0e3dc684085b3b27fe4cfd93f2.png";